// extracted by mini-css-extract-plugin
export default {"loader_box":"Loader_loader_box__-s6Bq","loader":"Loader_loader__+lRPl"};